<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">
        <div class="pure-g">

          <div class="pure-u-1 spacing-30"></div>

          <div class="pure-u-1 pure-u-sm-11-24">
            <div class="pure-g">
              <div class="pure-u-sm-1-8"></div>
              <div class="pure-u-1 pure-u-sm-7-8 text-center">
                <h3 class="margin-bottom-10 responsive"> New Account</h3>
                <div class="subtext-lg margin-left-10"> Don't have a Tavour account? </div>
              </div>
            </div>
          </div>

          <div class="pure-u-1 pure-u-sm-7-8 text-center visible-sm">
            <button class=" pure-button pure-button-primary block" @click="$emit('success')">Register</button>
          </div>

          <div class="pure-u-sm-2-24">
          <div class="vertical-line"></div>
          </div>
          <div class="pure-u-1 visible-sm ">
          <hr/>
          </div>


          <div class="pure-u-1 pure-u-sm-11-24">
            <div class="pure-g">
              <div class="pure-u-1 pure-u-sm-7-8 text-center">
                  <h3 class="margin-bottom-10 responsive">Returning Tavour Member</h3>
                  <div class="subtext-lg margin-left-10">Login to speed up the signup process.</div>
              </div>
              <div class="pure-u-sm-1-8"></div>
            </div>
          </div>

          <div class="pure-u-1 pure-u-sm-11-24 hidden-sm ">
            <div class="pure-g">
              <div class="pure-u-sm-1-8"></div>
              <div class="pure-u-1 pure-u-sm-7-8 text-center">
                <button class=" pure-button pure-button-primary block" @click="$emit('success')">Register</button>
              </div>
            </div>
          </div>

          <div class="pure-u-sm-2-24">
          <div class="vertical-line"></div>
          </div>


          <div class="pure-u-1 pure-u-sm-11-24">
            <div class="pure-g">
              <div class="pure-u-1 pure-u-sm-7-8 text-center">
                <button class=" pure-button pure-button-primary block" @click="$emit('login')"> Login</button>
              </div>
              <div class="pure-u-sm-1-8"></div>
            </div>
          </div>

          <div class="pure-u-1 spacing-20"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'Start',
    created() {
      /* global ga */
      ga('send', 'pageview', `/${store.get('subscription')}/`);
    },
  };
</script>

<style scoped>
  hr {
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// Start.vue?03e46335